<template>
    <div>
        <div class="body-overlay" id="body-overlay"></div>
        <SearchPopup />
        <Header2 />
        <Banner />
        <Intro />
        <ProjectsDone />
        <Service />
        <Experience />
        <Team />
        <CTA />
        <Testimonial />
        <CaseStudy />
        <FAQ />
        <Contact />
        <Blog />
        <Client />
        <Instagram />
        <Footer />
    </div>
</template>

<script>
    import SearchPopup from '@/components/layout/SearchPopup.vue'
    import Header2 from '@/components/layout/Header2.vue'
    import Client from '@/components/page/home/Client.vue'
    import Instagram from '@/components/page/home/Instagram.vue'
    import Footer from '@/components/layout/Footer.vue'

    export default {
        name: "Home",
        components: {
            SearchPopup,
            Header2,
            Client,
            Instagram,
            Footer
        },
    }
</script>


// WEBPACK FOOTER //
// src/pages/Home2.vue